import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';    
import Header from '../master_root/header';
//page links  
export default function Codeofconduct() {
  return (
           <div >
       <Header /> 
     <div className='app_header_height'></div>
    <div className="container_roots">
    <Helmet>
        <title>Code of Conduct - EditorTask</title>
        <meta name="description" content="Read the EditorTask Code of Conduct. We promote respectful, inclusive, and safe behavior for everyone using our platform." />
        <meta name="keywords" content="editor task code of conduct, community rules, user behavior, editor platform policy, job portal ethics" />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Code of Conduct - EditorTask" />
        <meta property="og:description" content="Read the EditorTask Code of Conduct. We promote respectful, inclusive, and safe behavior for everyone using our platform." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.editortask.com/code-of-conduct" />
        <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
      </Helmet>
      <div className="container_size">
        <h2 className="contact-title">Code of Conduct</h2>
        
        <div className="conduct-section">
          <p>
            At <b>EditorTask</b>, we’re building a creative and professional community where trust, respect, and collaboration thrive. To ensure a safe and welcoming space for all users, we’ve outlined our community Code of Conduct.
          </p>

          <h3>1. Be Respectful</h3>
          <p>Respect others’ opinions, work, and privacy. Personal attacks, discrimination, hate speech, or any form of harassment will not be tolerated.</p>

          <h3>2. Be Honest</h3>
          <p>Only publish or upload work you’ve created or have permission to share. Do not plagiarize, misrepresent your skills, or falsify experience.</p>

          <h3>3. Professional Communication</h3>
          <p>Maintain clear, kind, and constructive communication. Treat others as you would in a professional setting — with courtesy and clarity.</p>

          <h3>4. No Spam or Scams</h3>
          <p>Do not promote fake jobs, deceptive offers, or spam other users. Abusing the platform for commercial gain in misleading ways will lead to account suspension.</p>

          <h3>5. Respect Intellectual Property</h3>
          <p>Always respect copyright laws and do not share content or assets without proper rights or credit.</p>

          <h3>6. Safe Collaboration</h3>
          <p>Keep transactions, messaging, and collaborations on EditorTask for safety. Avoid sharing sensitive personal or payment details outside the platform.</p>

          <h3>7. Report Misconduct</h3>
          <p>If you witness any behavior that violates this code, please report it to us. Our team will review and take appropriate action swiftly.</p>

          <h3>8. Consequences</h3>
          <p>Violating this Code of Conduct may result in warnings, restricted features, or permanent removal from the platform.</p>

          <br/>
          <p>Thank you for helping us maintain a respectful and professional community at EditorTask.</p>
        </div>
      </div>
      </div>
</div>
    );
}
